import React, { useState, useEffect, useRef, useCallback } from "react";
import "../styles/AnnouncementBar.css";
import { Link } from "react-router-dom";

const AUTO_SLIDE_INTERVAL = 4000;

const announcements = [
  <>
    Need a Shopify expert? Get your free TechTCL call.&nbsp;
    <Link to="/contact" className="announcement-link">
      {" "}
      Contact Us
    </Link>
  </>,
  "New feature: 1-click Shopify store setup — ask us how!",
  "Limited offer: Free audit for your Shopify store this month.",
];

const AnnouncementBar = () => {
  const [current, setCurrent] = useState(0);
  // animDir: null | 'next' | 'prev'
  // during animation we show [slideA, slideB] in the track
  const [anim, setAnim] = useState(null); // { dir, from, to }
  const isAnimating = useRef(false);
  const timerRef = useRef(null);

  const slide = useCallback((direction) => {
    if (isAnimating.current) return;
    isAnimating.current = true;

    setCurrent((c) => {
      const next =
        direction === "next"
          ? (c + 1) % announcements.length
          : (c - 1 + announcements.length) % announcements.length;

      setAnim({ dir: direction, from: c, to: next });
      return c;
    });
  }, []);

  // When animation ends, commit the new slide
  useEffect(() => {
    if (!anim) return;
    const t = setTimeout(() => {
      setCurrent(anim.to);
      setAnim(null);
      isAnimating.current = false;
    }, 460);
    return () => clearTimeout(t);
  }, [anim]);

  // Auto-slide
  useEffect(() => {
    timerRef.current = setInterval(() => slide("next"), AUTO_SLIDE_INTERVAL);
    return () => clearInterval(timerRef.current);
  }, [slide]);

  const handleNav = (direction) => {
    clearInterval(timerRef.current);
    slide(direction);
    timerRef.current = setInterval(() => slide("next"), AUTO_SLIDE_INTERVAL);
  };

  // Build the two slides for the track
  // For "next": [current, incoming] → track slides left (−50%)
  // For "prev": [incoming, current] → track starts at −50%, slides to 0
  const renderTrack = () => {
    if (!anim) {
      // Static: just show current, no animation class
      return (
        <div className="announcement-track">
          <div className="announcement-text">{announcements[current]}</div>
          {/* dummy second slot so layout is stable */}
          <div className="announcement-text" aria-hidden="true" />
        </div>
      );
    }

    const first = anim.dir === "next" ? anim.from : anim.to;
    const second = anim.dir === "next" ? anim.to : anim.from;

    return (
      <div className={`announcement-track slide-${anim.dir}`}>
        <div className="announcement-text">{announcements[first]}</div>
        <div className="announcement-text">{announcements[second]}</div>
      </div>
    );
  };

  return (
    <div className="main-announcement-bar">
      <div className="announcement-bar">
        <button
          className="announcement-nav-btn"
          onClick={() => handleNav("prev")}
          aria-label="Previous"
        >
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path
              d="M7.5 2L3.5 6L7.5 10"
              stroke="currentColor"
              strokeWidth="1.6"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>

        <div className="announcement-text-wrapper">{renderTrack()}</div>

        <button
          className="announcement-nav-btn"
          onClick={() => handleNav("next")}
          aria-label="Next"
        >
          <svg width="12" height="12" viewBox="0 0 12 12" fill="none">
            <path
              d="M4.5 2L8.5 6L4.5 10"
              stroke="currentColor"
              strokeWidth="1.6"
              strokeLinecap="round"
              strokeLinejoin="round"
            />
          </svg>
        </button>
      </div>
    </div>
  );
};

export default AnnouncementBar;
